import {Injectable} from "@angular/core";
import {Observable, Observer, share} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {DataClientError, DisplayableDataServerMessage} from "./data-client-error";

/**
 * Error handling for the data client.
 */

@Injectable()
export class ErrorService {
    private dataClientErrorsObserver: Observer<DataClientError>;
    private errorsObserver: Observer<any>;

    constructor(private translate: TranslateService) {
        this._dataClientErrors = new Observable<DataClientError>(observer => {
            this.dataClientErrorsObserver = observer
        }).pipe(share());

        this._errors = new Observable<any>(observer => {
            this.errorsObserver = observer
        }).pipe(share());
    }

    private _dataClientErrors: Observable<DataClientError>;

    /**
     * Returns an observable sequence of DataClientError.
     * @returns {Observable<DataClientError>}
     */
    get dataClientErrors(): Observable<DataClientError> {
        return this._dataClientErrors;
    }

    private _errors: Observable<any>;

    /**
     * Returns an observable sequence of errors.
     * @returns {Observable<DataClientError>}
     */
    get errors(): Observable<any> {
        return this._errors;
    }

    reportError(error: any): void {
        if (this.errorsObserver) {
            this.errorsObserver.next(error);
        }
    }

    async reportDataClientError(dataClientError: DataClientError): Promise<void> {
        const displayableMessage: DisplayableDataServerMessage = await dataClientError.displayableMessage;
        if (dataClientError.displayableMessage) {
            this.translate.get(displayableMessage.messageKey, displayableMessage.messageParams).subscribe((translation: string) => {
                dataClientError.message = translation;
                if (this.dataClientErrorsObserver) {
                    this.dataClientErrorsObserver.next(dataClientError);
                }
            });
        } else {
            if (this.dataClientErrorsObserver) {
                this.dataClientErrorsObserver.next(dataClientError);
            }
            console.log(dataClientError.status + " - " + await dataClientError.message);
        }
    }
}

